// 範囲指定（マーキー）選択のための純粋な幾何ヘルパー。
// ドラッグの始点・終点（ステージ座標）から正規化した矩形を作り、その矩形に
// 重なるオブジェクト ID を求める。DOM やストアには依存しないため単体テストしやすい。

import { aabbIntersects, type Aabb } from "./culling";

/** 範囲指定枠（ステージ座標・幅高さは常に非負）。 */
export interface MarqueeRect {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

/**
 * ドラッグ始点 (x0,y0) と現在点 (x1,y1) から、左上原点・非負サイズの矩形へ正規化する。
 * どの向きにドラッグしても同じ矩形として扱えるようにする。
 */
export function normalizeMarqueeRect(
  x0: number,
  y0: number,
  x1: number,
  y1: number
): MarqueeRect {
  return {
    x: Math.min(x0, x1),
    y: Math.min(y0, y1),
    w: Math.abs(x1 - x0),
    h: Math.abs(y1 - y0),
  };
}

/**
 * 範囲指定枠に AABB が重なる（辺が接する場合も含む）オブジェクトの ID を返す。
 * 回転は考慮せず、各オブジェクトの x/y/w/h（未回転 AABB）で交差判定する。
 * 描画順とは無関係に Object.entries の列挙順で返す。
 */
export function objectIdsInMarquee<T extends Aabb>(
  objects: Record<string, T>,
  rect: MarqueeRect
): string[] {
  const ids: string[] = [];
  for (const [id, object] of Object.entries(objects)) {
    if (aabbIntersects(rect, { x: object.x, y: object.y, w: object.w, h: object.h })) {
      ids.push(id);
    }
  }
  return ids;
}
